import React from "react";
import { Formik } from "formik";
import logo from "../../../assets/images/new_logo_dark.svg";
import { Button } from "../../atoms/Button";
import { Loader } from "../../atoms/Loader";
import { InputWithLabel } from "../../molecules/InputWithLabel";
import {
  Body,
  ButtonWrapper,
  Container,
  ErrorMessage,
  Header,
  HeaderText,
  InputWrapper,
  Logo,
} from "./elements";

const ResetPasswordForm = ({ onSubmit, validate, isLoading }: any) => {
  return (
    <Container>
      <Header>
        <Logo src={logo} alt="logo" />
        <HeaderText>Reset your password</HeaderText>
      </Header>
      <Body>
        <Formik
          onSubmit={onSubmit}
          initialValues={{ password: "", confirm_password: "" }}
          validate={validate}
        >
          {({ values, handleChange, handleSubmit, errors }) => (
            <form onSubmit={handleSubmit}>
              <InputWrapper>
                <InputWithLabel
                  name="password"
                  onChange={handleChange("password")}
                  value={values.password}
                  label={"New Password"}
                  type={"password"}
                />
                {errors.password && (
                  <ErrorMessage>{errors.password}</ErrorMessage>
                )}
              </InputWrapper>
              <InputWrapper>
                <InputWithLabel
                  name="confirm_password"
                  onChange={handleChange("confirm_password")}
                  value={values.confirm_password}
                  label={"Re-enter New Password"}
                  type={"password"}
                />
                {errors.confirm_password && (
                  <ErrorMessage>{errors.confirm_password}</ErrorMessage>
                )}
              </InputWrapper>
              <ButtonWrapper>
                {isLoading ? (
                  <Loader />
                ) : (
                  <Button type="primary" htmlType={"submit"}>
                    Change Password
                  </Button>
                )}
              </ButtonWrapper>
            </form>
          )}
        </Formik>
      </Body>
    </Container>
  );
};

export default ResetPasswordForm;
